import axios from "axios";
import getConfig from "./config";

const api = axios.create({
  baseURL: getConfig()?.APP_API,
  withCredentials: getConfig()?.REQUEST_WITH_CREDENTIALS || false,
  headers: {
    tenantId: localStorage.getItem("tenantId") ?? "",
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("svrJwtAccessToken");
  if (token) {
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export default api;